<template>
  <div v-if="visible" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-md w-full max-w-2xl">
      <h2 class="text-xl mb-4">{{ $t('ui.emergency_info_modal.title') }}</h2>
      <div class="mb-4" style="max-height: 300px; overflow-y: auto;">
        <div v-html="emergencyInfo"></div>
      </div>
      <div class="flex justify-end">
        <button type="button" @click="$emit('close')" class="bg-blue-500 text-white px-4 py-2 rounded-md">
          {{ $t('ui.emergency_info_modal.understood') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    customerSlug: {
      type: String,
      default: null
    }
  },
  computed: {
    emergencyInfo() {
      return this.emergencyInfoByCustomer[this.customerSlug] || this.emergencyInfoByCustomer['default'];
    }
  },
  data() {
    return {
      emergencyInfoByCustomer: {
        'default': `
          <p>Informazioni di emergenza generiche.</p>
          <p>In caso di emergenza, mantenere la calma e seguire le indicazioni del personale.</p>
          <p>Le uscite di emergenza sono indicate dai segnali verdi.</p>
          <p>Il punto di raccolta è situato nel parcheggio principale.</p>
        `,
        'page93-srl': `
          <p><strong>Informazioni di Emergenza -page93-srl</strong></p>
          <p>In caso di emergenza, utilizzare le scale di emergenza situate ai lati dell'edificio.</p>
          <p>I punti di raccolta sono situati nel parcheggio nord.</p>
          <p>Contattare il numero di emergenza: 555-123-4567</p>
        `,
        'bona-spa': `
            <p class="py-2"><strong>Gentile Ospite, benvenuto presso lo stabilimento del Gruppo VINCENZO BONA.</strong></p>
            <p class="py-2">Riteniamo la sicurezza, l’igiene e la protezione ambientale fattori molto importanti.</p>
            <p class="py-2">A tal proposito, con questo modulo, vorremmo darvi indicazione riguardo le regole basilari di comportamento, sicurezza, igiene e protezione ambientale, da applicare all’interno dello stabilimento.</p>
            <p class="py-2">Vi chiediamo gentilmente di attendere il proprio referente interno presso la Reception e spostarsi all’interno del sito solo se accompagnati dal referente.</p>
            <strong class="py-2">REGOLE GENERALI</strong>
            <ul>
                <li style="display: flex; align-items: center;">
                    <img src="/images/icons/reception-digitale/vietato-fumare.png" class="h-14 mb-2" style="margin-right: 8px;"> 
                    È vietato fumare, eccetto che nelle aree indicate.
                </li>
                <li style="display: flex; align-items: center;">
                  <img src="/images/icons/reception-digitale/divieto-ingresso.png" class="h-14 mb-2" style="margin-right: 8px;"> 
                  È vietato l'accesso alle aree di lavoro senza autorizzazione.
                </li>
                <li style="display: flex; align-items: center;">
                  <img src="/images/icons/reception-digitale/pericolo-caduta.png" class="h-14 mb-2" style="margin-right: 8px;">
                  È necessario prestare attenzione a eventuali punti di pericolo sul pavimento (gradini, pavimenti scivolosi, ecc.).
                </li>
                <li style="display: flex; align-items: center;">
                  In caso di malore o di problemi di salute, segnalarlo prontamente al proprio accompagnatore.
                </li>
            </ul>
            <p class="py-2">Vi auguriamo una piacevole e sicura visita!</p>
            <strong class="py-2">COMPORTAMENTO IN CASO DI EMERGENZA</strong>
            <p class="py-2">All’interno dell’edificio sono presenti addetti all’antincendio ed al primo soccorso in numero adeguato a gestire eventuali situazioni di emergenza.</p>
            <strong class="py-2">IN CASO DI EVACUAZIONE DEI LOCALI:</strong>
            <ul>
                <li>- Rivolgersi al proprio Referente e seguire le istruzioni da lui impartite.</li>
                <li>- In caso di evacuazione (tramite altoparlanti o segnalatori ottico-acustici):</li>
                <ul>
                    <li>- Portarsi all’esterno seguendo i percorsi indicati dai cartelli a sfondo verde.
                       <img src="/images/icons/reception-digitale/uscita-di-emergenza.png" class="h-14 mb-2" style="margin-right: 8px;">
                      </li>
                    <li>- In caso di difficoltà, chiedere aiuto.</li>
                    <li>- Non gridare, non correre e mantenere la calma.</li>
                    <li>- Raggiungere il <strong>PUNTO DI RACCOLTA</strong> identificato nella planimetria allegata.</li>
                </ul>
            </ul>
             <p class="py-2"></p>
            <strong class="py-2">IN CASO DI EMERGENZA INCENDIO:</strong>
            <p class="py-2">Se si nota un principio di incendio, avvisare il proprio referente. Se assente, contattare altro personale del Gruppo Vincenzo Bona.</p>
            <strong class="py-2">IN CASO DI EMERGENZA SANITARIA:</strong>
            <p class="py-2">In caso si noti una persona in difficoltà, avvisare il proprio referente o altro personale vicino.</p>
            <div class="py-2">
                <p><strong>NUMERO UNICO DI EMERGENZA: 112</strong></p>
            </div>
        `
      }
    }
  }
}
</script>
